import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "@mui/material";

const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "fullName", headerName: "Full Name", width: 130 },
  { field: "dob", headerName: "Date of Birth", width: 130 },
  { field: "age", headerName: "Age", width: 130 },
  { field: "kycStatus", headerName: "KYC Status", width: 130 },
  { field: "userWalletAmount", headerName: "Wallet Amount", width: 160 },
  {
    field: "userRequestedAmount",
    headerName: "Requested Amount",
    width: 160,
  },
  {
    field: "action",
    headerName: "Action",
    renderCell: (params) => {
      const onClick = (e) => {
       
        e.stopPropagation(); // don't select this row after clicking

   

        return alert(JSON.stringify(params.row, null, 4));
      };

      return <Button onClick={onClick}>Process Request</Button>;
    },
    width: 160,
  },
];

const rows = [
  {
    id: 1,
    fullName: "John Samules",
    dob: "10/10/1996",
    age: "26",
    kycStatus: "Pending",
    userWalletAmount: "2500",
    userRequestedAmount: "2000",
    action: <button>Text</button>,
  },
  {
    id: 2,
    fullName: "John Smith",
    dob: "10/10/1996",
    age: "26",
    kycStatus: "Approved",
    userWalletAmount: "3000",
    userRequestedAmount: "3000",
  },
];

export default function WithdrawRequestTable() {
  return (
    <div style={{ height: 400, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[100]}
      />
    </div>
  );
}
